// extracted by css-extract-rspack-plugin
export default {"root":"root-FaqIiT","content":"content-obCzxt flex justify-between items-center","consultationBookedTime":"consultationBookedTime-E8M20Z text-body-label"};